import type { ClubConfigData, ClubConfigParams } from '@/api/clubMember/clubMemberType'
import { deepClone } from '@alova/shared'
import { defineStore } from 'pinia'
import { requestGetClubConfig, requestPostUpdateClubConfig } from '@/api/clubMember/clubMember'
import { EnumCommissionAssumption } from '@/typings'

// 初始化状态
const clubConfigInfoState: ClubConfigData = {
  clubId: '',
  huifuId: '',
  acctId: '',
  cardNo: '',
  depositBalance: '',
  availableBalance: '',
  clubCommission: '',
  commissionRate: '',
  commissionType: '',
  // 邀请人佣金比例
  inviteCommissionPercent: '',
  // 红包佣金比例
  redPacketCommissionPercent: '',
  // 俱乐部优惠承担方式（MERCHANT_BEARING-商户承担，AVERAGE-平摊）
  discountFlag: EnumCommissionAssumption.MERCHANT_BEARING,
  delayDays: 0,
  enableDeposit: false,
  updatedAt: '',
  // 邀请返点共同承担（true-俱乐部和陪玩共同承担，false-仅俱乐部承担）
  inviteCommissionShared: false,
  // 邀请返点是否允许超出俱乐部返点（true-允许，false-不允许）
  inviteCommissionAllowExceed: false,
  /** 是否强制校验接待订单完成凭证,(是否显示 “确认完成” 按钮，false显示，true不显示 ) */
  // orderConfirmForceCheck: false,
}

// 俱乐部配置
export const clubConfigStore = defineStore(
  'clubConfig',
  () => {
    // 俱乐部配置
    const clubConfig = ref<ClubConfigData>(deepClone(clubConfigInfoState))

    /**
     * 获取俱乐部配置
     * @return 俱乐部配置
     */
    async function getClubConfig(): Promise<ClubConfigData | undefined> {
      const { data } = await requestGetClubConfig()
      if (data) {
        clubConfig.value = data
        return data
      }
      else {
        return undefined
      }
    }

    /**
     * 更新俱乐部配置
     */
    async function setClubConfig(data: ClubConfigParams) {
      await requestPostUpdateClubConfig(data)
      await getClubConfig()
    }
    return {
      clubConfig,
      getClubConfig,
      setClubConfig,
    }
  },
)
